import * as React from 'react'
import Layout from '../components/layout'
import {
  lightFont,
  indent1,
  inputGroup,
  stoneLabel,
  stoneInput,
  timeInput,
  timeLabel,
  footnote,
} from './calculator.module.css'
import { getLang } from '../components/common.js'
import {
  monocleBonusDict,
  chaliceBonusDict,
} from '../components/artifacts-data.js'

const tachMultDict = {
  "1x 1000": 1000,
}

const bbMultDict = {
  "1x 50": 50,
  "2x 50": 2*50,
}

export default class MultistigeCalculatorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tach: "1x 1000",
      bb: "2x 50",
      monocle: "None",
      chalice: "None",
      lifeStonesT2: "",
      lifeStonesT3: "",
      lifeStonesT4: "",
      c3: "",
      t3m: "",
      t3s: "",
      boostm: "",
      boosts: "",
      lifewarn: "",

      chickensPerLeg: "",
      timePerLeg: "",
      stigeN1: 1,
      nstigeChickensPerLeg: "",
      nstigeTimePerFirstLeg: "",
      nstigeTimePerLeg: "",
    }
  }

  handleInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({[name]: value}, this.solveMultistige);
  }

  solveMultistige = () => {
    const lang = getLang();
    const options = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    };
    const options2 = {
      minimumFractionDigits: 1,
      maximumFractionDigits: 2
    };

    const tachMult = tachMultDict[this.state.tach];
    const bbMult = bbMultDict[this.state.bb];
    const monocleMult = 1 + monocleBonusDict[this.state.monocle];
    const chaliceMult = 1 + chaliceBonusDict[this.state.chalice];
    const lifeMult = Math.pow(1.02, parseInt(this.state.lifeStonesT2 | 0)) * Math.pow(1.03, parseInt(this.state.lifeStonesT3 | 0)) * Math.pow(1.04, parseInt(this.state.lifeStonesT4 | 0));
    const c3 = this.state.c3 * Math.pow(10, 9);

    const cps = 7440 * 4 / 60 * tachMult * bbMult * monocleMult * chaliceMult * lifeMult;
    const t3 = 60.0 * this.state.t3m + 1 * this.state.t3s;
    const t4 = (Math.sqrt(6241*Math.pow(c3,2) - 882*c3*cps*t3 + 441*Math.pow(cps,2)*Math.pow(t3,2)) - 79*c3 + 79*cps*t3) / (58*cps);
    const c4 = (t4-t3) * cps + c3;
    const t4m = Math.floor(Math.round(t4)/60);
    const t4s = Math.round(t4) - t4m * 60;
    const t4str = t4m.toLocaleString(lang, options) + "m " + t4s.toLocaleString(lang, options) + "s";
    const c4b = c4 / Math.pow(10, 9);

    const boostTotal = 60.0 * this.state.boostm + 1 * this.state.boosts;
    const n = Math.round((boostTotal + t3 - c3 / cps)/t4)
    const t4n = (boostTotal + t3 - c3 / cps)/n
    
    const t4nm = Math.floor(Math.round(t4n)/60);
    const t4ns = Math.round(t4n) - t4nm * 60;
    const t4nstr = t4nm.toLocaleString(lang, options) + "m " + t4ns.toLocaleString(lang, options) + "s";
    const c4n = (t4n-t3) * cps + c3;
    const c4nb = c4n / Math.pow(10, 9);
    const t4nfirst = c4 / cps;
    const t4nfirstm = Math.floor(Math.round(t4nfirst)/60);
    const t4nfirsts = Math.round(t4nfirst) - t4nfirstm * 60;
    const t4nfirststr = t4nfirstm.toLocaleString(lang, options) + "m " + t4nfirsts.toLocaleString(lang, options) + "s";
    
    if (lifeMult !== 1.0)
        this.setState({lifewarn: " (Don't you have better stones to be using?)"})
    else
        this.setState({lifewarn: ""})

    this.setState({chickensPerLeg: c4b.toLocaleString(lang, options2)});
    this.setState({timePerLeg: t4str});
    this.setState({stigeN1: n.toLocaleString(lang, options)});
    this.setState({nstigeChickensPerLeg: c4nb.toLocaleString(lang, options2)});
    this.setState({nstigeTimePerFirstLeg: t4nfirststr});
    this.setState({nstigeTimePerLeg: t4nstr});
  };

  render() {
    return (
      <Layout pageTitle="Multistige Calculator">
        <h1 className={lightFont}>Multistige Calculator</h1>
        <p className={indent1}>This calculator will give recommendations for your multistige. Assumes max ER. A standard multistige starts on a maxed research Universe farm with low population.</p>
        <p className={indent1}>Two key pieces of information are needed before using this tool. How long it takes you to finish research on Universe after hitting the prestige button and population at that time.</p>

        <h2 className={lightFont}>Inputs</h2>

        <div className={indent1}>
          <div className={inputGroup}>
            <div>Tachyon Prism</div>
            <select name="tach" value={this.state.tach} onChange={this.handleInputChange}>
              {Object.keys(tachMultDict).map(key => (
                <option>{key}</option>
              ))}
            </select>
          </div>
          <div className={inputGroup}>
            <div>Boost Beacon</div>
            <select name="bb" value={this.state.bb} onChange={this.handleInputChange}>
              {Object.keys(bbMultDict).map(key => (
                <option>{key}</option>
              ))}
            </select>
          </div>
          <div className={inputGroup}>
            <div>Monocle</div>
            <select name="monocle" value={this.state.monocle} onChange={this.handleInputChange}>
              {Object.keys(monocleBonusDict).map(key => (
                <option>{key}</option>
              ))}
            </select>
          </div>
          <div className={inputGroup}>
            <div>Chalice</div>
            <select name="chalice" value={this.state.chalice} onChange={this.handleInputChange}>
              {Object.keys(chaliceBonusDict).map(key => (
                <option>{key}</option>
              ))}
            </select>
          </div>
          <div className={inputGroup}>
            <div>Total Life Stones<span>{this.state.lifewarn}</span></div>
            <div>
              <label className={stoneLabel} htmlFor="lifeStonesT2">T2:</label>
              <input className={stoneInput} name="lifeStonesT2" type="number" min="0" value={this.state.lifeStonesT2} onInput={this.handleInputChange} />
              <label className={stoneLabel} htmlFor="lifeStonesT3">T3:</label>
              <input className={stoneInput} name="lifeStonesT3" type="number" min="0" value={this.state.lifeStonesT3} onInput={this.handleInputChange} />
              <label className={stoneLabel} htmlFor="lifeStonesT4">T4:</label>
              <input className={stoneInput} name="lifeStonesT4" type="number" min="0" value={this.state.lifeStonesT4} onInput={this.handleInputChange} />
            </div>
          </div>
          <div className={inputGroup}>
            <div>Chickens when research done (in billions)</div>
            <input name="c3" type="number" min="0" value={this.state.c3} onInput={this.handleInputChange} placeholder="e.g. 1.7, 2.1, ..." />
          </div>
          <div className={inputGroup}>
            <div>Time from prestige to research done</div>
            <div>
              <input className={timeInput} name="t3m" type="number" min="0" value={this.state.t3m} onInput={this.handleInputChange} />
              <label className={timeLabel} htmlFor="t3m">min</label>
              <input className={timeInput} name="t3s" type="number" min="0" value={this.state.t3s} onInput={this.handleInputChange} />
              <label className={timeLabel} htmlFor="t3s">sec</label>
            </div>
          </div>
          <div className={inputGroup}>
            <div>Total boost time</div>
            <div>
              <input className={timeInput} name="boostm" type="number" min="0" value={this.state.boostm} onInput={this.handleInputChange} />
              <label className={timeLabel} htmlFor="boostm">min</label>
              <input className={timeInput} name="boosts" type="number" min="0" value={this.state.boosts} onInput={this.handleInputChange} />
              <label className={timeLabel} htmlFor="boosts">sec</label>
            </div>
          </div>
        </div>

        <h2 className={lightFont}>Results</h2>

        <div className={indent1}>
          <p>These results maximize SE gain rate with effectively infinite boost time.</p>
          <div>Optimal Chickens per Leg (in billions)</div>
          <input value={this.state.chickensPerLeg} readOnly />
          <div>Optimal Time per Leg</div>
          <input value={this.state.timePerLeg} readOnly />
          <br/>
          <p>Given your total boost time, try doing a <span>{this.state.stigeN1}</span>-stige at <span>{this.state.nstigeChickensPerLeg}</span>b chickens. Take this as a recommended starting point and always test for yourself which is best.</p>
          <div>N-stige Chickens per Leg (in billions)</div>
          <input value={this.state.nstigeChickensPerLeg} readOnly />
          <div>N-stige Time for First Leg</div>
          <input value={this.state.nstigeTimePerFirstLeg} readOnly />
          <div>N-stige Time per Full Leg</div>
          <input value={this.state.nstigeTimePerLeg} readOnly />
          <br/>
          <br/>
          <p className={footnote}>Important Note: To do this calculation exactly requires many variables which are a burden to record, so this calculator makes certain assumptions to vastly simplify the inputs needed. The results may be off by one for certain cases.</p>
          <br/>
        </div>

      </Layout>
    )
  }
}